// src/types/hspital.ts

export interface HospitalSerializer {
  hospitalUuid?: string
  hospitalCode?: string
  hospitalIndustrialAccidentCode?: string | null
  hospitalType?: string
  hospitalDepartment?: string
  hospitalName?: string
  hospitalBusinessNo?: string
  hospitalBusinessType?: string
  hospitalBusinessItem?: string
  hospitalAddress?: string
  hospitalTel?: string
  hospitalDirectorName?: string
  hospitalDirectorBirth?: string
  effectiveDate?: string
  expirationDate?: string
  isActive?: boolean
  hospitalStatus?: string | null
  planType?: string | null
  hospitalStartDate?: string | null
  hospitalContractReceived?: boolean | null
  hospitalCmsFeeReceived?: boolean | null
  hospitalCmsDigitalSignatureReceived?: boolean | null
  hospitalCmsSmsReceived?: boolean | null
}

export interface HospitalResponse {
  code: number
  message: string
  result: HospitalSerializer
}

export const initialHospitalState: HospitalSerializer = {
  hospitalUuid: "",
  hospitalCode: "",
  hospitalIndustrialAccidentCode: "",
  hospitalType: "",
  hospitalDepartment: "",
  hospitalName: "신규",
  hospitalBusinessNo: "",
  hospitalBusinessType: "",
  hospitalBusinessItem: "",
  hospitalAddress: "",
  hospitalTel: "",
  hospitalDirectorName: "",
  hospitalDirectorBirth: "",
  effectiveDate: "",
  expirationDate: "",
  isActive: true,
  hospitalStatus: null,
  planType: null,
  hospitalStartDate: null,
  hospitalContractReceived: null,
  hospitalCmsFeeReceived: null,
  hospitalCmsDigitalSignatureReceived: null,
  hospitalCmsSmsReceived: null,
}

export interface HospitalBuhangcupSerializer {
  hospitalBuhangcupId?: number
  isActive?: boolean
  isCurrentValid?: boolean
  hospitalBuhangcupCode?: string
  hospitalBuhangcupName?: string
  hospitalBuhangcupCompany?: string
  hospitalBuhangcupMakerCompany?: string
  hospitalBuhangcupMaxPrice?: string
  effectiveDate?: string
  expirationDate?: string
}

export interface HospitalBuhangcupResponse {
  code: number
  message: string
  result: HospitalBuhangcupSerializer[]
}
